import createAnimationWrapper from "./createAnimationWrapper";
import  calc from "../../utils/calc";

const anim = ({x='0',y='0'}) => ({
  "0%": { transform: "translate(0,0)" },
  "50%": { transform: `translate(${calc(`${x} / 2`)}, ${y})` },
  "100%": { transform: `translate(${x}, 0)` }
});

const Base = createAnimationWrapper(anim, {
  duration: "1s",
});

const HopTo = ({to={}, ...props}) => <Base animation={anim(to)} {...props} />;

export default HopTo;
